import script from "./CustomVoiceChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomVoiceChat.vue?vue&type=script&lang=ts&setup=true"

import "./CustomVoiceChat.vue?vue&type=style&index=0&id=900bb1b0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-900bb1b0"]])

export default __exports__